module.exports = __webpack_public_path__ + "img/GH.601f9fed.svg";